import axios from 'axios';

const list = (data) => axios.get('/safe/alarm/list', data);
const save = (data) => axios.post('/safe/alarm/save', data);
const del = (data) => axios.post('/safe/alarm/delete', data);


export default {
  list,
  save,
  del,

}


